"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _Block = _interopRequireDefault(require("@material-ui/icons/Block"));

var _EnhancedEncryption = _interopRequireDefault(require("@material-ui/icons/EnhancedEncryption"));

var _Lock = _interopRequireDefault(require("@material-ui/icons/Lock"));

var _LockOpen = _interopRequireDefault(require("@material-ui/icons/LockOpen"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ACL_OPTIONS = {
  PUBLIC: {
    label: 'publiek'
  },
  REGISTERED: {
    label: 'enkel wanneer geregistreerd'
  },
  ON_REQUEST: {
    label: 'enkel op aanvraag'
  },
  PRIVATE: {
    label: 'enkel voor medewerkers'
  }
};

var ACLHeaderToggleButton = function ACLHeaderToggleButton(_ref) {
  var acl = _ref.acl,
      onAclChange = _ref.onAclChange,
      labels = _ref.labels;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      anchorEl = _useState2[0],
      setAnchorEl = _useState2[1];

  var handleAclChange = function handleAclChange(option) {
    setAnchorEl(null);
    onAclChange(option);
  };

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    "aria-label": "acl",
    "aria-controls": "acl-menu",
    "aria-haspopup": "true",
    onClick: function onClick(event) {
      return setAnchorEl(event.currentTarget);
    }
  }, acl === 'PUBLIC' ? /*#__PURE__*/_react["default"].createElement(_LockOpen["default"], null) : acl === 'ON_REQUEST' ? /*#__PURE__*/_react["default"].createElement(_EnhancedEncryption["default"], null) : acl === 'PRIVATE' ? /*#__PURE__*/_react["default"].createElement(_Block["default"], null) : /*#__PURE__*/_react["default"].createElement(_Lock["default"], null)), /*#__PURE__*/_react["default"].createElement(_core.Menu, {
    id: "long-menu",
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: function onClose() {
      return setAnchorEl(null);
    }
  }, Object.keys(ACL_OPTIONS).map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
      key: option,
      selected: option === acl,
      onClick: function onClick() {
        return handleAclChange(option);
      }
    }, labels[option] || ACL_OPTIONS[option].label);
  })));
};

var _default = ACLHeaderToggleButton;
exports["default"] = _default;